import { useLanguageContext } from "../../context/LanguageContext";
import PasswordResetPage from "../../pages/password_reset/PasswordResetPage";
import { RouteConfig } from "./RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function usePasswordResetRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/password_reset")
    .setLabel(translate("eva.main.auth.password_reset.confirm.header"))
    .setPage(<PasswordResetPage />);
}

export default usePasswordResetRouteConfig;
